export const ORDER_ID_PARAMETER = 'basketId';
export const INVOICE_TYPE_PARAMETER = 'orderType';
export const ORDER_STATUS_ID_PARAMETER = 'orderStatusId';
export const FAILED_ORDER_PARAMETER = 'paymentFailed';
export const B2B_INVOICE_ID_PARAMETER = 'invoiceId';
export const WORKSHOP_ID_PARAMETER = 'workshopId';
export const STORE_SERVICE_ID_PARAMETER = 'storeServiceId';
